import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { usePaddock } from 'app/agriculture/queries/entities/usePaddock';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';

export function HerdPaddockDisplay({
    herdId,
    latestBefore,
}: {
    herdId: string;
    latestBefore: Date | null;
}) {
    const snapshot = useSnapshot({
        snapshotType: 'Herd',
        parentId: herdId,
        shelfLife: null,
        cursorTimeOverride: latestBefore ?? undefined,
    });
    const paddock = usePaddock(snapshot?.paddockId);
    const isPaddockNull = snapshot?.paddockId === null;
    return (
        <StatDisplay
            id="herd-from-paddock"
            name="From Paddock"
            value={isPaddockNull ? 'Offsite' : paddock?.name}
            emptyStateMessage="No past data"
        />
    );
}
